export const convertSecondsToDays = (seconds: number) =>
  seconds > 0 ? seconds / (60 * 60 * 24) : 0;

export enum PriceFreezeDurationSelectionMethod {
  Slider,
  Buttons,
  Toggle,
};
